import React from 'react'
import $t from '../../../i18n'
import { useSelector } from 'react-redux'
import config from '../../../config.json'
import './ContactSupport.css'

const ContactSupport = ({ title }) => {
  const antidoteSupportPhone = useSelector(
    state => state.app.antidoteSupportPhone
  )
  const antidoteSupportEmail = useSelector(
    state => state.app.antidoteSupportEmail
  )

  return (
    <div className='contact-support-container'>
      <div className='title'> {title || $t('alerts.noItems')} </div>
      <div className='subtitle'>{$t('contactSupport.title')}</div>
      <div className='support-details'>
        <a href={`tel:${antidoteSupportPhone}`}>
          {$t('contactSupport.tel')} {antidoteSupportPhone}
        </a>
        <a className='link' href={`mailto:${antidoteSupportEmail}`}>
          {antidoteSupportEmail}
        </a>
      </div>
      <img
        src={config.gcpStorageUrl + '/img/contact_support.png'}
        className='contact-support-img'
        alt=''
      />
    </div>
  )
}

export default ContactSupport
